import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment.service';
import { ErrorService } from '../errors/error.service';

@Injectable({
  providedIn: 'root'
})
export class AddStateService {
  private readonly STATE_URL: string = '/dpwsvc/v1/ext/code/';
  private readonly STATE_CODE: string = 'GROUP_STATE_CODE';

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private errorService: ErrorService
  ) {}

  /**  state map consists of key - value */
  private _stateMap: Map<string, string> = new Map<string, string>();

  public get stateMap(): Map<string, string> {
    return this._stateMap;
  }

  public set stateMap(stateMap: Map<string, string>) {
    this._stateMap = stateMap;
  }

  public setupStateServiceCall() {
    return this.http
      .get<Map<string, string>>(
        this.environmentService.getServer() + this.STATE_URL + this.STATE_CODE
      )
      .subscribe(
        res => {
          this._stateMap = res as Map<string, string>;
        },
        error => {
          this.errorService.processError(error);
        }
      );
  }
}
